export default __webpack_public_path__ + "static/media/user-key-blue.0261d63d.svg";